import __request__ from "routing/request";
export function systemStats() {
  return __request__("GET", "/system/cluster/stats", null, {}, {
    "Accept": ["application/json"]
  });
}
export function elasticsearchStats() {
  return __request__("GET", "/system/cluster/stats/elasticsearch", null, {}, {
    "Accept": ["application/json"]
  });
}
export function mongoStats() {
  return __request__("GET", "/system/cluster/stats/mongo", null, {}, {
    "Accept": ["application/json"]
  });
}
